import { useInfiniteQuery } from "@tanstack/react-query";
import QueryString from "qs";
import { StrapiProductAttribute, StrapiResponse } from "~/shared-types";
import { strapiClient as defaultStrapiClient } from "~/strapi/api";
import { EMPTY_STRAPI_RESPONSE, QueryFunctionOptions, getNextPageParam, getQueryObject } from "./shared";

export const PRODUCT_ATTRIBUTES_QUERY_KEY = "productAttributes";

export async function getProductAttributes(options: QueryFunctionOptions = {}) {
  const { strapiClient = defaultStrapiClient } = options;
  const queryObject = getQueryObject(options);
  const query = QueryString.stringify(queryObject);
  const { data } = await (strapiClient as any).get("/product-attributes?" + query);
  return data as StrapiResponse<StrapiProductAttribute[]>;
}

export const useProductAttributesQuery = (
  options: QueryFunctionOptions = {},
  initialData?: StrapiResponse<StrapiProductAttribute[]>
) => {
  const { enabled = true } = options;
  const queryObject = getQueryObject(options);
  const query = QueryString.stringify(queryObject);
  return useInfiniteQuery({
    queryKey: [PRODUCT_ATTRIBUTES_QUERY_KEY, query],
    queryFn: async ({ pageParam = 1 }) => getProductAttributes({ ...options, pageParam }),
    enabled,
    getNextPageParam,
    initialPageParam: initialData ? 1 : undefined,
    initialData: {
      pages: [initialData],
      pageParams: [initialData ? 1 : undefined],
    },
  });
};
